export default __webpack_public_path__ + "static/media/Microphone.acacea74.svg";